import React, { useEffect } from 'react'
import { Grid, IconButton, Typography, withStyles } from '@material-ui/core'
import { Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Icon from '@mdi/react'
import { mdiMessageQuestion } from '@mdi/js'

import styles from '../../../resources/theme/global'
import colors from '../../../assets/colors'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { fetchBillingType } from '../BillingTypeActions'
import { getBillingTypeListData } from '../BillingTypeReducer'
import Filter from './Filter'
import List from './List'
import New from './New'
import Edit from './Edit'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'

const BillingType = props => {
  const dispatch = useDispatch()
  const location = useLocation()

  const filters = useQueryParams(location.search)

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate, canRead, canUpdate } = usePermissions()

  const { classes } = props

  useEffect(() => {
    dispatch(fetchBillingType(filters, filters?.rows || 10, filters?.page || 1))
  }, [location])

  return (
    <BaseCreatePage page={'Financeiro'} hiddenReturn path={'Centro de custo'}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Filter classes={classes} />
          </Grid>

          {canRead('centro-custo', permissionUser) && (
            <Grid item xs={12}>
              <List classes={classes} />
            </Grid>
          )}
        </Grid>
      </Grid>

      {canCreate('centro-custo', permissionUser) && (
        <Route path="/billing-type/new" component={New} />
      )}
      {canUpdate('centro-custo', permissionUser) && (
        <Route path="/billing-type/:id/edit" component={Edit} />
      )}
    </BaseCreatePage>
  )
}

export default withStyles(styles)(BillingType)
